export default "__VITE_ASSET__CndFsKFz__"